import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
} from "@mui/material";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import {
  LogButton,
  ViewButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch, useSelector } from "react-redux";
import Loader3D from "../../../../../components/Loader/Loader3D";
import { getFeePerSession } from "../../../../../redux/features/CRDslice";

const Feepersession = ({ data, CourseEnrollId ,isDisable}) => {
  const [open, setOpen] = useState(false);

  const { loading, feePerSession } = useSelector((state) => state.crd);

  const dispatch = useDispatch();

  const headers = ["Subject", "Fee Per Session"];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 14,
      border: "1px solid #ccc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "1px solid #ccc",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  useEffect(() => {
    if (open) {
      dispatch(getFeePerSession(CourseEnrollId));
    }
  }, [open]);

  return (
    <GlobalDialog
      title="Fee Per Session"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={"sm"}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)} disabled={isDisable}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <GlobalWrapper>
              <Paper
                sx={{
                  margin: 1,
                  borderRadius: 4,
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #ccc",
                    borderCollapse: "collapse",
                    marginTop: 2,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {headers.map((header, index) => (
                        <StyledTableCell key={index} align="center">
                          {header}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {feePerSession?.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="center">
                          {row.subject_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.cro_fee_per_session}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </GlobalWrapper>
          )}
        </>
      }
    />
  );
};

export default Feepersession;
